import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import config from "../../config";
import $ from "jquery";
import Swal from "sweetalert2";
import "react-tooltip/dist/react-tooltip.css";
import { ContextBoard } from "../../context/ContextBoard";
import { motion, AnimatePresence } from "framer-motion";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function Checklistgenerated12() {
  const { setCandidateid12, setMode12, setClass12regulardata, setDocverify12 } =
    useContext(ContextBoard);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [studentData, setStudentData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const iframeRef = useRef(null);
  const [modalData, setModalData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState("");

  const [EndDate, setEndDate] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };
  const token = sessionStorage.getItem("tokenclassxii");
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        // setIsLoading(true);
        const response = await fetch(
          `${config.API_BASE_URL}/FetchListChecklistGenerated_CL12`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({
            //   schooL_CODE: schoolCode,
            // }),
          }
        );

        if (!response.ok) {
          // Swal.fire({
          //   icon: "warning",
          //   title: "Data not found!",
          // });
          return;
        }

        const data = await response.json();
        setStudentData(data.data.checklistStatus || []);

        // console.log(data.data["student-data"] || []);
      } catch (error) {
        console.error("Error fetching students:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const filteredStudents = studentData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.gender?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.includes(query) ||
      student.castE_NAME?.toLowerCase().includes(query) ||
      student.checklisT_STATUS?.toLowerCase().includes(query) ||
      student.stream?.toLowerCase().includes(query) ||
      student.studenT_EXAM_CATEGORY_DESCRIPTION?.toLowerCase().includes(query)
    );
  });

  const handleEdit = async (id, category, reg_no, regsession, doc) => {
    // debugger;
    if (doc === "NO") {
      setDocverify12(true);
    } else {
      setDocverify12(false);
    }
    setCandidateid12(id);
    setMode12("edit");

    if (category === "EX-REGULAR") {
      // navigate(`/class-x-add-ex-regular-student`);
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GetStudentByCandidateIdForEdit_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: id,
            }),
          }
        );

        const result = await response.json();

        if (!response.ok || result.status === 404) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message || "Something went wrong",
          });
          return;
        }
        navigate("/class-xii-add-ex-regular-info-jac", {
          state: { studentData: result.data.editStudent_data },
        });
      } catch (error) {
        console.error("Error fetching data:", error.message);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Failed to fetch data",
        });
      }
    } else if (category === "IMPROVEMENT") {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GetStudentByCandidateIdForEditBetterment_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: id,
            }),
          }
        );

        const result = await response.json();

        if (!response.ok || result.status === 404) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message || "Something went wrong",
          });
          return;
        }
        navigate("/class-xii-add-improvement-info", {
          state: { studentData: result.data },
        });
      } catch (error) {
        console.error("Error fetching data:", error.message);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Failed to fetch data",
        });
      }
    } else if (category === "QUALIFYING") {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GetStudentByCandidateIdForEditQualifying_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: id,
            }),
          }
        );

        const result = await response.json();

        if (!response.ok || result.status === 404) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message || "Something went wrong",
          });
          return;
        }
        navigate("/class-xii-add-qualifying-info", {
          state: { studentData: result.data },
        });
      } catch (error) {
        console.error("Error fetching data:", error.message);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Failed to fetch data",
        });
      }
    } else {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GetStudentByCandidateIdForEdit_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: id,
            }),
          }
        );

        const result = await response.json();

        if (!response.ok || result.status === 404) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message || "Something went wrong",
          });
          return;
        }

        setClass12regulardata(true);

        navigate("/class-xii-regular-student-info", {
          state: { candidateData: result.data.editStudent_data },
        });
      } catch (error) {
        console.error("Error fetching data:", error.message);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Failed to fetch data",
        });
      }
    }
  };

  const handleViewRemarks = (remarks) => {
    setSelectedRemarks(remarks || "No remarks available.");
    setShowModal(true);
  };
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div class="container-scroller">
      <Navbar12 />
      {isLoading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-fluid page-body-wrapper">
        <Sidebar12 />
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 mb-1">
                <section class="content-header">
                  <h1>
                    <i class="fa fa-user"></i>&nbsp;Checklist Generated
                  </h1>
                  <ol class="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/class-xii-dashboard");
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: "-4px" }}
                        >
                          <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                        </svg>{" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li class="active">Checklist Generated</li>
                  </ol>
                  <h3></h3>
                </section>
              </div>
            </div>
            <div class="row" style={{ padding: "0px" }}>
              <div
                class="col-md-12 mb-4 stretch-card"
                style={{ padding: "3px" }}
              >
                <div class="card">
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <div style={{ width: "250px" }}>
                          <select
                            id="rowsPerPage"
                            className="form-select form-select-sm"
                            value={perPage}
                            onChange={handlePerPageChange}
                            style={{
                              width: "80px", // or adjust as needed (80–120px)
                              paddingRight: "2rem", // ensures space for the dropdown arrow
                            }}
                          >
                            {[10, 20, 50, 100, 500].map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Search on the right */}
                      <div style={{ width: "200px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>

                    {isLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className="table-info">
                              <th>Sl No.</th>
                              <th>Checklist Status</th>
                              <th>Stream </th>
                              <th>Category</th>
                              <th>Name of Candidate </th>
                              <th>Gender</th>
                              <th>Date of Birth</th>
                              <th>Father's Name</th>
                              <th>Mother's Name</th>
                              <th>Caste </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="11" className="text-center">
                                  No data found.
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    {(currentPage - 1) * perPage + index + 1}
                                  </td>

                                  <td>
                                    <span class="badge bg-success border border-success">
                                      <i class="fa fa-check"></i>&nbsp;PRINTED
                                    </span>
                                  </td>
                                  <td>
                                    {/* {row.challaN_STATUS === "NOT GENERATED" ? (
                                      <>
                                        <span className="badge bg-danger border border-danger">
                                          <i className="fa fa-times"></i>
                                          &nbsp;
                                          {row.challaN_STATUS ||
                                            "NOT GENERATED"}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span className="badge bg-success border border-success">
                                          <i className="fa fa-check"></i>
                                          &nbsp;
                                          {row.challaN_STATUS || "GENERATED"}
                                        </span>
                                      </>
                                    )} */}
                                    {row.stream}
                                  </td>
                                  <td>
                                    <b className="text-danger">
                                      {row.studenT_EXAM_CATEGORY_DESCRIPTION ||
                                        ""}
                                    </b>
                                  </td>
                                  <td>{row.candidatE_NAME || ""}</td>
                                  <td>{row.gender.toUpperCase() || ""}</td>
                                  <td>{row.dob}</td>
                                  <td>{row.fatheR_NAME || ""}</td>
                                  <td>{row.motheR_NAME || ""}</td>
                                  <td>
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        color: "red",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {row.castE_NAME || ""}
                                    </span>
                                  </td>
                                  <td>
                                    {row.challaN_STATUS === "NOT GENERATED" && (
                                      <a
                                        className="btn btn-sm btn-info"
                                        onClick={() =>
                                          handleEdit(
                                            row.candidatE_ID,
                                            row.studenT_EXAM_CATEGORY_DESCRIPTION,
                                            row.refferencE_NO,
                                            row.registratioN_SESSION,
                                            row.doC_STATUS
                                          )
                                        }
                                      >
                                        <i className="fa fa-edit"></i>
                                        &nbsp;Edit
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer12 />
          <AnimatePresence>
            {showModal && (
              <motion.div
                className="modal-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1050,
                }}
              >
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.8, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="modal-content p-4 bg-white rounded"
                  style={{ width: "400px", position: "relative" }}
                >
                  <h5 className="mb-3">DEO Rejection Remarks</h5>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={selectedRemarks}
                    readOnly
                  />
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default Checklistgenerated12;
